export default __webpack_public_path__ + "static/media/DeleteBlogTag.b5cce850.svg";